import { createTaskFactory } from './createTaskFactory';

/**
 * Run a low-resource task
 * @param functions
 * @returns {function(*, *=): Promise<T>}
 */
export default function createTask(functions) {
  return createTaskFactory(functions, 'handleTask');
}
